export var TransportType;
(function (TransportType) {
    TransportType["XHR"] = "xhr";
    TransportType["SendBeacon"] = "beacon";
    TransportType["Fetch"] = "fetch";
})(TransportType || (TransportType = {}));
//# sourceMappingURL=transport.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@amplitude/analytics-types/lib/esm/transport.js
// module id = 196
// module chunks = 0